
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars",
      function () {
        return require("private-next-pages/cars.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars"])
      });
    }
  